angular.module('app')
    .service('httpRequestInterceptor', ['$q', '$rootScope', 'customer', function ($q, $rootScope, $customer) {
        var html = ".html";
        var tpl = ".tpl";

        // Workaround for logout race condition
        // After a customer's password is revoked, we start getting 403's from calls which proxy to Product.  The
        // first time we get one, we clear out our session and attempt to redirect to the "new password" page.
        // Subsequent calls to Product then fail because the session isn't valid rather than due to the password being
        // revoked.  Those failures would trigger a redirect to the regular login page if we didn't have this latch.
        // When detect a revoked password we set this to true to prevent redirects to the login page so that the
        // redirect to the "new password" page can complete.
        var isSessionRevoked = false;

        var simulateLogOut = function () {
            $rootScope.$broadcast('logOutPressed');
        };

        var sessionExpired = function() {
            if (!isSessionRevoked) {
              $rootScope.$broadcast('sessionExpired');
            }
        };

        var passwordReset = function() {
            if (!isSessionRevoked) {
              $rootScope.$broadcast('passwordReset');
            }
        };

        var sessionRevoked = function() {
            if (!isSessionRevoked) {
                isSessionRevoked = true;
                $rootScope.$broadcast('sessionRevoked');
            }
        };

        var sessionNoAuth = function() {
            if (!isSessionRevoked) {
                $rootScope.$broadcast('sessionNoAuth');
            }
        };

        var requestRejected = function(rejection) {
            if (!isSessionRevoked) {
                $rootScope.$broadcast('requestRejected', rejection);
            }
        };

        var handleBadRequestError = function(rejection) {
            var error = rejection.data || {};
            // for validation errors, we don't want show the R'box
            if (!_.isUndefined(error.apiError) &&
                error.apiError.errorType === 'VALIDATION') {
                return;
            }

            switch (error.code) {
                case 5100: // bulk upload validation error
                    // the error(s) will be shown under the invalid field(s)
                    break;
                case 6000: // ast not found
                    // the error(s) will be handled in the different controllers
                    break;
                default:
                    requestRejected(rejection);
                    break;
            }
        };

        var handleSettingsError = function(rejection) {
            var error = rejection.data || {};
            switch (error.code) {
                case 1002: // validation error
                    // the error(s) will be shown under the invalid field(s)
                    break;
                case 3232: // entity locked
                    $rootScope.$broadcast('requestError', {code: error.code, message: error.message});
                    break;
                default:
                    requestRejected(rejection);
                    break;
            }
        };

        var getApiError = function(rejection) {
            if (!rejection || !rejection.data || _.isUndefined(rejection.data.apiError)) {
                return '';
            }
            var error = rejection.data.apiError;
            return 'ApiError code: ' + error.code + ', errorLocator: ' + error.errorLocator + ', message: ' + error.message;
        };

        return {
            request: function (config) {
                var isTemplate = config.url.indexOf(tpl) > -1;
                var isHtml = config.url.indexOf(html) > -1;
                var isStaticResource = config.url.indexOf('/resources/') === 0 || config.url.indexOf('resources/') === 0;

                if (config.method === 'GET' && !isTemplate && !isHtml) {
                    config.params = config.params || {};

                    if ($customer.getAcademicStandard() && config.params.ast === undefined) {
                        var standard = $customer.getAcademicStandard();
                        config.params.ast = standard.academic_standard_name;
                    }
                }

                if (config.method === 'GET' && isStaticResource && !isTemplate) {
                    if (typeof $rootScope.build_time !== 'undefined') {
                        config.url = config.url.replace(/(\/?resources\/.+?)(\.[a-zA-Z0-9]+)([?#].*)?$/,
                          '$1.' + $rootScope.build_time + '$2$3');
                    }
                }

                return config;
            },

            response: function (response) {
                return response || $q.when(response);
            },

            responseError: function (rejection) {
                var reason;
                try {
                    console.warn('request to ' + rejection.config.url + ' failed with status ' + rejection.status + ' ' + rejection.statusText + '. ' + getApiError(rejection));
                } catch (e) {
                    // No need to do anything here, we just want to prevent failing unnecessarily if rejection doesn't contain expected attributes.
                }

                switch (rejection.status) {
                    case 0:
                        // noop; we get zero status from canceled requests (e.g. during state transitions,
                        // when pending requests get cancelled). no need to take action.
                        break;

                    case 403:
                        reason = (rejection.headers() || {}).reason;
                        if (reason === 'expired') {
                            console.error("Session expired");
                            sessionExpired();
                        } else if(reason === 'reset') {
                            console.info("Password reset");
                            passwordReset();
                        } else if (reason === 'revoked') {
                            console.info("Session revoked");
                            sessionRevoked();
                        } else if (reason === 'session_unauthorized') {
                            console.error("Session is not authorized");
                            sessionNoAuth();
                        } else {
                            console.warn("Resource request forbidden");
                            requestRejected(rejection);
                        }
                        break;
                    case 400:
                        handleBadRequestError(rejection);
                        break;
                    case 406:
                        handleSettingsError(rejection);
                        break;
                    default:
                        requestRejected(rejection);
                }
                return $q.reject(rejection);
            }
        };
    }]);
